var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, Fragment as _Fragment } from "vue";
var _hoisted_1 = {
    key: 1,
    class: "profile-btn mr-8 px-4 relative",
    id: "avatar-profile"
};
var _hoisted_2 = ["src", "alt"];
import { onMounted, computed } from 'vue';
import { useAcknowledgementStore, useAuthStore, useProfileStore } from "../../store";
import { sendSigninPage } from '../../utils';
import { getCookie, removeCookie } from '../../utils/cookies';
import Snackbars from '../molecules/Snackbars.vue';
import AlertDialog from '../atoms/AlertDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'AuthArea',
    props: { // プロパティの定義
    },
    emits: [ // イベントの定義
    ],
    setup: function (__props, _a) {
        var _this = this;
        var emits = _a.emit;
        var props = __props;
        var acknowledgementStore = useAcknowledgementStore();
        var authStore = useAuthStore();
        var profileStore = useProfileStore();
        var userProfile = computed(function () {
            return profileStore.$state;
        });
        var moveSigninPage = function (event) {
            event.preventDefault();
            sendSigninPage(location, window.scrollY);
        };
        var addFullstarScript = function () {
            if (document.querySelector('script[src="https://view.fullstar10.com/js/review.js"]')) {
                // スクリプトが既に存在する場合は、再度読み込まない
                initializeFullstar();
                return;
            }
            // スクリプト要素を作成
            var script = document.createElement('script');
            script.type = 'application/javascript';
            script.async = true;
            script.src = 'https://view.fullstar10.com/js/review.js';
            // スクリプトがロードされたら関数を実行
            script.onload = function () {
                initializeFullstar();
            };
            // スクリプト要素をDOMに追加
            document.head.appendChild(script);
        };
        var initializeFullstar = function () {
            var currentDomain = window.location.hostname;
            var tagId = currentDomain === 'media.engate.jp' ? '9bb7d1dd-7046-4406-b533-2eae6f5229d1' : 'ebc956d9-1f4f-446d-9a26-8e780c8506e9';
            var companyName = currentDomain === 'media.engate.jp' ? 'Engate Media(本番)' : 'Engate Media(STG/ローカル)';
            // ログインの有無で値を変更
            var tagsValue = authStore.isAuth ? 'login_user' : '';
            var userId = authStore.isAuth ? profileStore.$state.engate_id : 'ユーザーのUUID';
            var userName = authStore.isAuth ? profileStore.$state.name : 'ユーザーの氏名';
            var userEmail = authStore.isAuth ? profileStore.$state.email : 'ユーザーのEmail';
            // スクリプトの初期化
            var scriptContent = "\n    fs.clear();\n    fs.show(\"".concat(tagId, "\", \"").concat(userId, "\", {\n      company_name: \"").concat(companyName, "\",\n      user_name: \"").concat(userName, "\",\n      user_email: \"").concat(userEmail, "\",\n      plan_name: \"\u30E6\u30FC\u30B6\u30FC\u306E\u30D7\u30E9\u30F3\u540D\",\n      tags: \"").concat(tagsValue, "\"\n    });\n    fs.tracking();\n    fs.survey();\n    fs.guide();\n    fs.checklist();\n    fs.tooltip();\n  ");
            var script = document.createElement('script');
            script.type = 'text/javascript';
            script.textContent = scriptContent;
            document.head.appendChild(script);
            /*
            //@ts-ignore
            fs.clear();
            //@ts-ignore
            fs.show("ebc956d9-1f4f-446d-9a26-8e780c8506e9", userId, {
                company_name: "Engate Media",
                user_name: userName,
                user_email: userEmail,
                plan_name: "ユーザーのプラン名",
                tags: tagsValue
            });
            //@ts-ignore
            fs.tracking();
            //@ts-ignore
            fs.survey();
            //@ts-ignore
            fs.guide();
            //@ts-ignore
            fs.checklist();
            //@ts-ignore
            fs.tooltip();
            */
        };
        onMounted(function () { return __awaiter(_this, void 0, void 0, function () {
            var pageUrl, excludePages, isRT, urlParams, scrollPosition, autoScroll;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        addFullstarScript();
                        pageUrl = location.pathname;
                        excludePages = [
                            /\/registrations\//,
                            /\/provider\//,
                            /\/reset-password\//,
                            /\/customer\//,
                            /\/signin/,
                        ];
                        isRT = !excludePages.some(function (excludePage) {
                            if (excludePage instanceof RegExp) {
                                return excludePage.test(pageUrl);
                            }
                            else {
                                // 末尾に/がついた場合にNavigationDuplicatedとなるケースがあるため対応
                                return pageUrl === excludePage || pageUrl === "".concat(excludePage, "/");
                            }
                        });
                        return [4 /*yield*/, authStore.regenerateToken()];
                    case 1:
                        _a.sent();
                        if (!isRT) return [3 /*break*/, 3];
                        return [4 /*yield*/, authStore.regenerateToken()];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        if (!(!authStore.isAuth && profileStore.hasProfileStore)) return [3 /*break*/, 5];
                        return [4 /*yield*/, profileStore.resetUserProfile()];
                    case 4:
                        _a.sent();
                        return [3 /*break*/, 7];
                    case 5:
                        if (!(authStore.isAuth && sessionStorage.getItem('tkn'))) return [3 /*break*/, 7];
                        return [4 /*yield*/, profileStore.setUserProfile()];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        urlParams = new URLSearchParams(window.location.search);
                        scrollPosition = urlParams.get('setScroll');
                        if (scrollPosition) {
                            autoScroll = Number(getCookie('setScroll'));
                            removeCookie('setScroll');
                            if (autoScroll > 0) {
                                window.scrollTo({
                                    top: parseInt(scrollPosition),
                                    behavior: 'smooth',
                                });
                            }
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        return function (_ctx, _cache) {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (!_unref(authStore).isAuth)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 0,
                        href: "/signin/",
                        onClick: moveSigninPage,
                        class: "btn-login px-4 py-2 mr-6 text-12px text-white border border-white"
                    }, "ログイン/新規登録"))
                    : (_openBlock(), _createElementBlock("button", _hoisted_1, [
                        _createElementVNode("img", {
                            src: String(userProfile.value.avatar),
                            class: "w-32px h-32px rounded-full border border-engate bg-black",
                            alt: String(userProfile.value.name)
                        }, null, 8, _hoisted_2)
                    ])),
                _createVNode(Snackbars),
                _createVNode(AlertDialog)
            ], 64));
        };
    }
});
